import { NgxsModule, Store, State, StateContext, Action, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, catchError, of } from 'rxjs';
import { SetLastOpened } from './dashboard-overview.action';

interface DashboardOverviewStateModel {
    lastOpenedIndex: number | null;
}

@State<DashboardOverviewStateModel>({
    name: 'dashboardOverview',
    defaults: {
        lastOpenedIndex: null
    }
})
@Injectable()
export class DashboardOverviewState {
    constructor(private http: HttpClient, private store: Store) {}

    @Selector()
    static getLastOpenedIndex(state: DashboardOverviewStateModel): number | null {
        return state.lastOpenedIndex;
    }

    @Action(SetLastOpened)
    setLastOpened(ctx: StateContext<DashboardOverviewStateModel>, action: SetLastOpened) {
        ctx.patchState({ lastOpenedIndex: action.lastOpenedIndex });
    }
}
